import React, { useEffect } from 'react'

import { SecurityConfigProvider } from './SecurityConfigProvider'
import { CredentialsProvider } from './CredentialsProvider'
import { SecurityConfig } from '../types'
import i18n from '../services/i18n'

interface Props {
  config?: SecurityConfig
  children: React.ReactNode | React.ReactNodeArray
}

export const SecurityProvider: React.FC<Props> = ({ config, children }) => {
  useEffect(() => {
    i18n.changeLanguage(config.defaultLanguage || 'de')
  }, [config.defaultLanguage])

  return (
    <SecurityConfigProvider value={config}>
      <CredentialsProvider>{children}</CredentialsProvider>
    </SecurityConfigProvider>
  )
}
